// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 76) return "static/chunks/76-c2014ad15d804dd2.js";
	if (chunkId === 4094) return "static/chunks/4094-8118fb5b75e7d3f3.js";
	if (chunkId === 6502) return "static/chunks/6502-d64e97d1b66a9541.js";
	if (chunkId === 7600) return "static/chunks/7600-294f6d90c709b43d.js";
	if (chunkId === 8594) return "static/chunks/8594-b207732acd31433d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"0fbc1475b2b96a07","2592":"c56719bdf8ce41ce","3156":"c38b8e787d86ab0c","3514":"93a3d91dc7cbd030","4686":"bfd59265abc97dd3","6534":"6bfbd467d772a951","9724":"c6b6864a768ec578","9835":"10847844b21a8b7a"}[chunkId] + ".js";
};